import { tailwindVariants } from '@air/utils-tailwind';

/** Reference and Actions menus share one interior height (Strato). */
export { WORKSPACE_AGENT_ACTIONS_MENU_POPOVER_MAX_HEIGHT_PX as WORKSPACE_AGENT_COMPOSER_REFERENCE_MENU_POPOVER_HEIGHT_PX } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentActionsMenuLayout';

export const workspaceAgentReferenceMenuPopover = tailwindVariants({
  slots: {
    content:
      'z-portal flex w-[var(--radix-popover-trigger-width)] flex-col overflow-hidden rounded-12 border border-gray-4 bg-gray-1 shadow-popover outline-none',
  },
});

export const WORKSPACE_AGENT_REFERENCE_MENU_TITLE = 'Reference';

export const workspaceAgentReferenceMenuHeader = tailwindVariants({
  slots: {
    row: 'flex shrink-0 items-center gap-1 border-gray-4 border-b px-2 py-2',
    titleCluster: 'flex min-w-0 flex-1 items-center gap-0.5',
    iconWrap: 'flex size-6 shrink-0 items-center justify-center text-gray-12',
    title: 'shrink-0 whitespace-nowrap font-medium text-14 text-gray-12 leading-5',
    chips: 'flex min-w-0 shrink-0 flex-nowrap items-center gap-1',
  },
});

export const workspaceAgentMentionContextsSelector = tailwindVariants({
  slots: {
    stickyButton:
      'sticky top-0 z-1 flex w-full items-center gap-1 bg-gray-3 px-3 py-2 text-left font-medium text-12 text-gray-10 leading-4',
    chevron: 'size-4 shrink-0',
    selectorLabelCluster: 'flex min-w-0 items-center gap-1',
    selectorLabelText: 'truncate',
    listbox: 'flex flex-col py-1',
    option:
      'flex w-full items-center gap-1 px-3 py-2 text-left font-medium text-12 text-gray-10 leading-4 hover:bg-gray-4 data-[highlighted]:bg-gray-4',
    optionSelected: 'bg-gray-4',
    rowList: 'flex flex-col gap-1 p-2',
    kitMenuContent: [
      'z-above-portal flex w-[var(--radix-popper-anchor-width)] min-w-[var(--radix-popper-anchor-width)] max-w-none flex-col gap-0 overflow-y-auto rounded-none border-0 bg-gray-1 p-0',
      'text-gray-10 shadow-none outline-none dark:border-0',
    ],
  },
});

export const workspaceAgentMentionContextsEmpty = tailwindVariants({
  slots: {
    // Strato-centered empty block inside the shared ~274px reference popover; no spacing token yet.
    root: 'flex min-h-[140px] flex-1 flex-col items-center justify-center gap-2 p-2 text-gray-8',
    message: 'text-12 text-gray-10 leading-4',
  },
});
